import { useEffect, useState } from "react";
import './App.css';
import Header from './Components/Header/Header';
import Whychoose from './Components/whychoose/Whychoose';
import Offer from './Components/offer/Offer';
import Contact from './Components/contact/Contact';
import Footer from './Components/footer/Footer';
import SideButtons from './Components/sidebutton/Sidebutton';
import PopupForm from "./Components/popupform/PopupForm";  // your popup

function App() {

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 9000); // 9 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <SideButtons />
      <Header />
      <Whychoose />
      <Offer />
      <Contact />
      <Footer />

      {/* POPUP SHOW CONDITION */}
      {showPopup && <PopupForm close={() => setShowPopup(false)} />}
    </>
  );
}

export default App;
